/** @jsx jsx */
import EmailIcon from '@atlaskit/icon/glyph/email';
import { N40, N500 } from '@atlaskit/theme/colors';
import { css, jsx } from '@emotion/react';
import React from 'react';
const getEmailAvatarWrapperStyle = isLozenge => {
  const padding = isLozenge ? `${"var(--ds-space-0, 0px)"}` : `${"var(--ds-space-050, 4px)"}`;
  return css({
    padding: padding,
    backgroundColor: `var(--ds-background-neutral, ${N40})`,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center'
  });
};
export const AddOptionAvatar = ({
  isLozenge,
  label
}) => {
  return jsx("div", {
    css: getEmailAvatarWrapperStyle(isLozenge)
  }, jsx(EmailIcon, {
    label: label,
    size: isLozenge ? 'small' : 'medium',
    primaryColor: `var(--ds-text-subtle, ${N500})`
  }));
};